export default "__VITE_ASSET__D0d75QzC__"